import React, { FunctionComponent, useState, useCallback } from 'react';
import digitalApi from '../../../../../common/api/digitalApi';
import errorHandler from '../../../../../common/service/errorHandler';
import Enquire from '../../../presentational/actionButtons/customiseEnquire/Enquire';
import IActionButtonProps from '../IActionButtonProps';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

const ContinueInDealerShipButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const {
    spc: {
      customise: { displayReserveOnline },
    },
  } = useTheme<ISpcTheme>();

  const onClick = useCallback(() => {
    setIsSubmitting(true);

    if (config.isCheckoutLiteEnabled && config.requestQuoteUrl) {
      return digitalApi
        .continueInDealership()
        .then(() => {
          setIsSubmitting(false);
          (window as any).location = config.requestQuoteUrl;
        })
        .catch(error => {
          setIsSubmitting(false);
          errorHandler.handleError(error);
        });
    }
  }, [config]);

  return (
    <Enquire
      onClick={onClick}
      disabled={isSubmitting || config.disabled}
      isPrimary={config.isCheckoutLiteEnabled && !displayReserveOnline}
    />
  );
};

export default ContinueInDealerShipButtonContainer;
